import deepDiffObj from "./modules/deepDiffObj";

let helpers = {
  deepDiffObj
}

let helperPlugin = {
  install(Vue) {
    Vue.helpers = helpers
    Vue.prototype.$helpers = helpers
  }
}

export default helperPlugin